let parentOrigin: string | undefined

export const setParentOrigin = (origin: string | undefined) => {
  parentOrigin = origin
}

export const postToParent = (message: unknown) => {
  if (parentOrigin) {
    window.parent.postMessage(message, parentOrigin)
  }
}

export const isMessageFromParent = (event: MessageEvent) =>
  event.source === window.parent && event.origin === parentOrigin
